import EventEmitter from "eventemitter3";
var eventEmitter = new EventEmitter();
export var Emitter = {
    emit: function(event, payload) {
        return eventEmitter.emit(event, payload);
    },
    off: function(event, fn) {
        return eventEmitter.off(event, fn);
    },
    on: function(event, fn) {
        return eventEmitter.on(event, fn);
    },
    once: function(event, fn) {
        return eventEmitter.once(event, fn);
    },
    removeListener: function(event, fn) {
        return eventEmitter.removeListener(event, fn);
    }
};
Object.freeze(Emitter);

//# sourceMappingURL=emitter.js.map